import { PayloadAction } from "@reduxjs/toolkit";
import { CollectionState } from "@/components/CollectionsPage/redux/types";

const CollectionReducer = {
  setCollectionData: (state: CollectionState, action: PayloadAction<any>) => {
    state.collectionData = action.payload;
  },

  setLoading: (state: CollectionState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },

  setError: (state: CollectionState, action: PayloadAction<any>) => {
    state.error = action.payload;
  },
};

export default CollectionReducer;
